import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface UserSettingsState {
  hasBranchesEnabled: boolean;
}

const initialState: UserSettingsState = {
  hasBranchesEnabled: false,
};

const userSettingsSlice = createSlice({
  name: "userSettings",
  initialState,
  reducers: {
    setBranchesEnabled(state, action: PayloadAction<boolean>) {
      state.hasBranchesEnabled = action.payload;
    },
    toggleBranchesEnabled(state) {
      state.hasBranchesEnabled = !state.hasBranchesEnabled;
    },
  },
});

export const { setBranchesEnabled, toggleBranchesEnabled } = userSettingsSlice.actions;
export default userSettingsSlice.reducer;
